// PageProjectViewHour Component

import React from 'react'
import _ from 'lodash'
import classnames from 'classnames'

import app from '../../../app.jsx'
import DateUtil from '../../../lib/dateutil.jsx'
import BaseProjectView from '../../page/base_projectview/base_projectview.jsx'
import Grid from '../../../common/common/grid/grid.jsx'
import List from '../../../../components/List/List.jsx'
import ContentMessage from '../../../common/common/content_message/content_message.jsx'
import HourUserContent from '../../hour/hour_usercontent/hour_usercontent.jsx'
import HourActivityContent from '../../hour/hour_activitycontent/hour_activitycontent.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import Acl from '../../../lib/acl.jsx'
import ReportPriceCell from '../../../report/report/report_pricecell/report_pricecell.jsx'
import ProfilerUtil from '../../../lib/profilerutil.jsx'
import Util from '../../../lib/util.jsx'

class PageProjectViewHour extends BaseProjectView {
  constructor (props) {
    super(props, 'projectview-hour', 'project', 'projectview-hour')

    this.state = {
      filterType: 'grid',
      contentType: 'activities',
      profilerId: null
    }

    this.data = {
      project: this._getProjectFromCache(this.props.projectId),
      sort: 'name',
      sortAsc: true,
      activitySort: 'activities',
      activities: [],
      users: [],
      pageState: {
        sort: this.state.contentType === 'activities' ? 'title' : 'name',
        sortAsc: true,
        type: 'grid',
        filter: null
      },
      stat: this._getOverviewStatFromCache(this.props.projectId)
    }

    /* Initialize profiler */
    this._profiler = new ProfilerUtil(this._pageIdent, 3) // Average time 3 seconds
    this._profiler.start()
    this._profiler.setParams(this.props.projectId)

    this._bUnMounted = false
  }

  componentDidMount () {
    app.updatePageTitle('project-hourview', 'Hour')
    this._getData(false)
    this._initProjectCommonEvents()

    // Calculate and save profiler, Hardcode profiler id as 1, since it is the first call of profiler
    this._profiler.stop(1)
  }

  componentWillUnmount () {
    this._bUnMounted = true
    this._releaseProjectCommonEvents()

    this._profiler = null
  }

  componentDidUpdate (prevProps, prevState) {
    if (
      this._profiler &&
      (!prevState || prevState.profilerId !== this.state.profilerId) &&
      this.state.profilerId
    ) {
      this._profiler.stop(this.state.profilerId)
    }
  }

  renderContent () {
    return (
      <div className='page-projectview-hour'>
        {this._renderMessage()}
        {this._renderHourContent()}
      </div>
    )
  }

  onAdd (event) {
    event.preventDefault()

    app.redirect('/timesheet')
  }

  _onChangeFilter (filter) {
    this.data.filter = filter

    if (filter.hoursContentType !== this.state.filterType) {
      this.setState({ filterType: filter.hoursContentType })
    } else {
      this.data.pageNo = 1
      this._reloadData()
    }

    if (filter.hoursFilterType !== this.state.contentType) {
      this.setState({ contentType: filter.hoursFilterType })
    } else {
      this.data.pageNo = 1
      this._reloadData()
    }
  }

  getContentClassname () {
    return this.state.filterType === 'grid' ? 'alt' : null
  }

  _getData (bReload) {
    // Start profiler
    const profilerId = this._profiler ? this._profiler.start() : 0

    const params = {
      query: {
        bUpdatePageState: bReload,
        pageState: this.data.pageState,
        pageIdent: this._pageIdent,
        projectId: this.props.projectId,
        project: {
          $client: {
            subObjects: {
              contact: ['company', 'rateCards', 'rateMarkup', 'rate']
            }
          }
        }
      }
    }

    app
      .service('/api/page/project/hour')
      .find(params)
      .then((result) => {
        if (result) {
          this._onPageDataRecieved(result.pageData)

          if (result.project) {
            this.data.project = result.project
            this._setProjectToCache(this.data.project)
          }
          if (result.hour) {
            this._processSorting(result.hour)
          }

          if (result.stat) {
            this.data.stat = result.stat
            this._setOverviewStatToCache(this.data.stat)
          }

          this._onDataReceived(null, profilerId)
        }
      })
      .catch((err) => {
        app.debug('PageProjectHour: _getData Error', err)
        this._onDataReceived(err, profilerId)
      })
  }

  _processSorting (hourResp) {
    if (hourResp && hourResp.activities && this.data.pageState.sort) {
      hourResp.activities = _.sortBy(
        hourResp.activities,
        this.data.pageState.sort
      )
      if (!this.data.pageState.sortAsc) {
        hourResp.activities.reverse()
      }
    }

    if (hourResp && hourResp.users && this.data.pageState.sort) {
      hourResp.users = _.sortBy(hourResp.users, this.data.pageState.sort)
      if (!this.data.pageState.sortAsc) {
        hourResp.users.reverse()
      }
    }

    this.data.activities = hourResp.activities
    this.data.users = hourResp.users
  }

  _onDataReceived (err, profilerId) {
    if (this._bUnMounted) return

    if (err) {
      app.debug('PageProjectHour: _onDataReceived Error', err)
      this.setState({
        loading: true,
        dataDate: new Date(),
        profilerId: profilerId
      })
    } else {
      app.debug('PageProjectHour: _onDataReceived [done]')
      this.setState({
        loading: this.data.activities && !this.data.activities.length > 0,
        dataDate: new Date(),
        profilerId: profilerId
      })
    }
  }

  _getListCloumns () {
    return [
      {
        label: 'project.list.labelName',
        identifier: 'name',
        width: '25%',
        sort: true,
        filterType: 'autocomplete',
        type: 'text'
      },
      {
        label: 'project.list.labelActivities',
        identifier: 'noActivities',
        width: '25%',
        sort: true,
        filterType: 'autocomplete',
        type: 'text'
      },
      {
        label: 'project.viewHour.labelSpentAmount',
        identifier: 'spentAmount',
        width: '15%',
        sort: true,
        type: 'custom',
        customType: 'price'
      },
      {
        label: 'project.viewHour.labelTrackedHours',
        identifier: 'trackedHours',
        width: '15%',
        sort: true,
        type: 'minutestotime'
      },
      {
        label: 'project.viewHour.labelPlannedHours',
        identifier: 'plannedHours',
        width: '20%',
        sort: true,
        type: 'minutestotime'
      }
    ]
  }

  _getSortOptions () {
    return [
      {
        label: 'project.list.labelName',
        value: 'name'
      },
      {
        label: 'project.list.labelActivities',
        value: 'noActivities'
      },
      {
        label: 'project.list.labelHours',
        value: 'timeTaken'
      }
    ]
  }

  _getActivityListCloumns () {
    return [
      {
        label: 'project.list.labelActivities',
        identifier: 'title',
        width: '20%',
        sort: true,
        filterType: 'autocomplete',
        type: 'text'
      },
      {
        label: 'project.viewHour.labelTotal',
        identifier: 'total',
        width: '25%',
        sort: true,
        type: 'custom',
        customType: 'price'
      },
      {
        label: 'project.viewHour.labelSpentAmount',
        identifier: 'spentAmount',
        width: '20%',
        sort: true,
        type: 'custom',
        customType: 'price'
      },
      {
        label: 'project.viewHour.labelTrackedHours',
        identifier: 'trackedHours',
        width: '15%',
        sort: true,
        type: 'minutestotime'
      },
      {
        label: 'project.viewHour.labelPlannedHours',
        identifier: 'plannedHours',
        width: '15%',
        sort: true,
        type: 'minutestotime'
      }
    ]
  }

  _getActivitySortOptions () {
    return [
      {
        label: 'project.viewHour.labelPhase',
        value: 'phasetitle'
      },
      {
        label: 'project.viewHour.labelActivities',
        value: 'title'
      },
      {
        label: 'project.viewHour.labelProgress',
        value: 'percentage'
      },
      {
        label: 'project.viewHour.labelSpentAmount',
        value: 'plannedHours'
      },
      {
        label: 'project.viewHour.labelTrackedHours',
        value: 'trackedHours'
      },
      {
        label: 'project.viewHour.labelPlannedHours',
        value: 'spentAmount'
      }
    ]
  }

  _onPaginate () {
    if (this.data.canPaginate) {
      const page = this.data.pageNo + 1
      this.data.pageNo = page
      this._reloadData()
    }
  }

  _onSort (sort, sortAsc) {
    this.data.pageState.sort = sort
    this.data.pageState.sortAsc = sortAsc
    this.data.pageNo = 1
    this._reloadData()
  }

  _reloadData () {
    this._getData(true)
  }

  _onListItemClick () {}

  _onActivityListItemClick () {}

  _renderHourContent () {
    if (this.state.loading) {
      return ''
    }

    if (this.state.contentType === 'activities') {
      return (
        <>
          {this._renderActivityGridOrList()}
          {this.state.filterType !== 'list' &&
            this._renderFooter(false, this.data.activities)}
        </>
      )
    }

    return (
      <>
        {this._renderUserGridOrList()}
        {this.state.filterType !== 'list' &&
          this._renderFooter(true, this.data.users)}
      </>
    )
  }

  _renderActivityGridOrList () {
    if (this.state.filterType === 'list') {
      return (
        <div className='listwrap'>
          <List
            objectList={this.data.activities}
            sortOptions={this._getActivitySortOptions()}
            columns={this._getActivityListCloumns()}
            onPaginate={this._onPaginate.bind(this)}
            onSort={this._onSort.bind(this)}
            renderCustomCell={this._onRenderActivityList.bind(this)}
            onView={this._onActivityListItemClick.bind(this)}
            sort={this.data.pageState.sort}
            sortAsc={this.data.pageState.sortAsc}
            onSettings={this._onActivityListItemClick.bind(this)}
          />
        </div>
      )
    }

    return (
      <div className='gridwrap'>
        <Grid
          objectList={this.data.activities}
          sortOptions={this._getActivitySortOptions()}
          onPaginate={this._onPaginate.bind(this)}
          onSort={this._onSort.bind(this)}
          sort={this.data.pageState.sort}
          sortAsc={this.data.pageState.sortAsc}
          onRenderGrid={this._onRenderActivityGrid.bind(this)}
        />
      </div>
    )
  }

  _renderUserGridOrList () {
    if (this.state.filterType === 'list') {
      return (
        <div className='listwrap'>
          <List
            objectList={this.data.users}
            sortOptions={this._getSortOptions()}
            columns={this._getListCloumns()}
            onPaginate={this._onPaginate.bind(this)}
            onSort={this._onSort.bind(this)}
            renderCustomCell={this._onRenderList.bind(this)}
            onView={this._onListItemClick.bind(this)}
            sort={this.data.pageState.sort}
            sortAsc={this.data.pageState.sortAsc}
            onSettings={this._onListItemClick.bind(this)}
          />
        </div>
      )
    }

    return (
      <div className='gridwrap'>
        <Grid
          objectList={this.data.users}
          sortOptions={this._getSortOptions()}
          onPaginate={this._onPaginate.bind(this)}
          sort={this.data.pageState.sort}
          sortAsc={this.data.pageState.sortAsc}
          onSort={this._onSort.bind(this)}
          onRenderGrid={this._onRenderGrid.bind(this)}
        />
      </div>
    )
  }

  _onRenderActivityGrid (activity, idx) {
    const _className = classnames('hour-usercont', {
      plannerdisabled: !Acl.isPlannerAllowed()
    })

    return (
      activity.trackedHours > 0 && (
        <div className={_className} key={idx}>
          {idx === 0 && (
            <div className='itemhdr'>
              <div className='itemcol coltitle'>
                <IntlMessage ident='project.viewHour.headerTitle' />
              </div>
              <div className='itemcol colactivity'>
                <IntlMessage ident='project.viewHour.headerBudget' />
              </div>
              <div className='itemcol colspent'>
                <IntlMessage ident='project.viewHour.headerSpend' />
              </div>
              <div className='itemcol colplanned'>
                <IntlMessage ident='project.viewHour.headerPlanned' />
              </div>
              <div className='itemcol coltracked'>
                <IntlMessage ident='project.viewHour.headerTracked' />
              </div>
            </div>
          )}
          <HourActivityContent
            activity={{ ...activity, expanded: true }}
            key={idx}
            onClickItem={this._onClickUserItem.bind(this, null)}
          />
        </div>
      )
    )
  }

  _onClickUserItem (user, item) {
    const project = this.data.project
    const currYear = DateUtil.getLocalYear()

    const filterObj = {
      contact: {
        label: project.contact.company,
        value: project.contactId
      },
      project: {
        label: project.title,
        value: project.id
      },
      user: {
        label: user ? user.name : item.name,
        value: user ? user.id : item.id
      },
      dateFilter: {
        ident: 'this-year',
        label: 'report.view.filterThisYear',
        value: {
          from: DateUtil.getUTCDate(currYear, 0, 1),
          to: DateUtil.getUTCDate(currYear, 11, 31)
        }
      },
      memberName: item.name,
      projectName: project.title,
      contactName: project.contact.company
    }

    app.changePage('report-view', 'time-registration', filterObj)
  }

  _onRenderGrid (user, idx) {
    const _className = classnames('hour-usercont', {
      plannerdisabled: !Acl.isPlannerAllowed()
    })

    return (
      <div className={_className} key={idx}>
        {idx === 0 && (
          <div className='itemhdr'>
            <div className='itemcol coltitle'>
              <IntlMessage ident='project.viewHour.headerTitle' />
            </div>
            <div className='itemcol colactivity'>
              <IntlMessage ident='project.viewHour.headerActivities' />
            </div>
            <div className='itemcol colspent'>
              <IntlMessage ident='project.viewHour.headerSpend' />
            </div>
            <div className='itemcol colplanned'>
              <IntlMessage ident='project.viewHour.headerPlanned' />
            </div>
            <div className='itemcol coltracked'>
              <IntlMessage ident='project.viewHour.headerTracked' />
            </div>
          </div>
        )}
        <HourUserContent
          user={user}
          key={idx}
          onClickItem={this._onClickUserItem.bind(this, user)}
        />
      </div>
    )
  }

  _onRenderActivityList (activity, column, idx) {
    const value = activity[column.identifier]
    const width = column.width

    if (column.customType === 'price') {
      return <ReportPriceCell price={value} width={width} key={idx} />
    }

    return ''
  }

  _onRenderList (user, column, idx) {
    const value = user[column.identifier]
    const width = column.width

    if (column.customType === 'price') {
      return <ReportPriceCell price={value} width={width} key={idx} />
    }

    return ''
  }

  _renderMessage () {
    if (this.state.loading) {
      return (
        <ContentMessage
          message='project.view.hoursTitle'
          info='project.view.addHoursInfo'
          showAdd
          onAdd={this.onAdd.bind(this)}
        />
      )
    }

    return ''
  }

  _renderFooter (bUserItem, objects) {
    const _className = classnames('totalinfo', {
      totalinfo_user: bUserItem,
      plannerdisabled: !Acl.isPlannerAllowed()
    })
    if (objects.length <= 0) {
      return null
    }

    let totalPlannedHours = 0
    let totalTrackedHours = 0

    if (objects) {
      objects.forEach((object) => {
        totalPlannedHours += object.plannedHours
        totalTrackedHours += object.trackedHours
      })
    }

    return (
      <div className={_className}>
        <div className='itemhdr'>
          <div className='itemcol coltitle'>
            <IntlMessage ident='project.viewHour.totalHours' />
          </div>
          <div className='itemcol colplanned'>
            {Util.convertMinutesToHour(totalPlannedHours * 60)}
          </div>
          <div className='itemcol coltracked'>
            {Util.convertMinutesToHour(totalTrackedHours * 60)}
          </div>
        </div>
      </div>
    )
  }

  /* Header Functions - Start */
  _onHeaderGridListToggle (isGridActive) {
    this.setState({ filterType: isGridActive ? 'grid' : 'list' })
  }

  _onHeaderContentFilter (option) {
    this.setState({ contentType: option.ident })
  }
  /* Header Functions - End */
}

export default PageProjectViewHour
